export default __webpack_public_path__ + "static/media/guide_03.35b870e8.md";